module.exports = __webpack_public_path__ + "static/media/record.c021f99a.svg";